<template>
  <!-- 景區管制 -->
  <div class="col text-end">
    <!-- <div class="card card-clean h-100"> -->
      <!-- <div class="card-header bg-white border-0 fw-bold text-indigo h5"> -->
        <!-- 景區管制狀態
        </div> -->
        <!-- <div class="card-body"> -->
        <!-- <div class="row d-flex align-items-center"> -->
          <!-- <div class=" d-flex col-12 text-align-2 justify-content-between"> -->
            <!-- <label
              class="custom-control border-switch mb-0"
              for="customSwitch"
              style="cursor: not-allowed"
            >
              <input
                type="checkbox"
                class="border-switch-control-input"
                id="customSwitch"
                v-model="isSenicAreaWarning"
                disabled
              />
              <span class="border-switch-control-indicator"></span>
              <p class="d-inline h6 fw-bolder">氣象預警</p>
            </label> -->
            <label
              class="custom-control border-switch mb-0 "
              for="customSwitch2"
            >
              <input
                type="checkbox"
                class="border-switch-control-input"
                id="customSwitch2"
                v-model="isSenicAreaControl"
                @change="changeControlStatus($event)"
                :disabled="isControlSwitchDisable"
                :style="[isControlSwitchDisable ? 'cursor: not-allowed;' : '']"
              />
              <span class="border-switch-control-indicator"></span>
              <p class="d-inline h6 fw-bolder">啟動管制</p>
            </label>
          </div>
    
        <!-- </div>
        </div>
  
      </div>
    
  </div> -->
</template>

<script>
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
import CONST from "../../utils/const";
import Utils from "../../utils/utils";
import { authentication, my } from "resource";
import { mapState, mapGetters } from "vuex";

export default {
  components: {},
  props: {
    selectedScenicAreaId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      dataInterval: null,
      //  測試非空值時間資料 (上機前須更改)
      // startTime:moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
      // endTime: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
      // startTime: "2022-12-16T00:00:00",
      // endTime: "2022-12-16T23:55:55",

      isSenicAreaWarning: false, //氣象預警
      isSenicAreaControl: false, //啟動管制
      isControlSwitchDisable: false,
      violationQueryTime: "",
     

    };
  },
  methods: {
    async getAllControlHistory() {
      await this.$store.dispatch("controlHistory/getAllControllHistory");
        this.checkSwitchsStatus();
    },
    checkSwitchsStatus() {
      const controlData = this.$store.getters[
        "controlHistory/getScenicControlData"
      ](this.selectedScenicAreaId);
      this.isSenicAreaWarning = controlData[CONST.CONTROL_TYPE.WARING]
        ? controlData[CONST.CONTROL_TYPE.WARING]
        : false;
      this.isSenicAreaControl = controlData[CONST.CONTROL_TYPE.CONTROL]
        ? controlData[CONST.CONTROL_TYPE.CONTROL]
        : false;

    console.log('check的',this.isSenicAreaControl)
      this.violationQueryTime = controlData.time ? controlData.time : null;
    },

    async changeControlStatus(event) {
      event.preventDefault();
      const confirmed = confirm("您確定要送出更改嗎？");
      this.isControlSwitchDisable = true; // 避免短時間連續修改
      if (confirmed) {
        const data = {
          scenicAreaId: this.selectedScenicAreaId,
          controlHistoryType: CONST.CONTROL_TYPE.CONTROL,
          controlswitch: this.isSenicAreaControl,
          fillAccount: this.accountName,
        };

        await this.$store.dispatch("controlHistory/postControllHistory", data);
      }

      this.isControlSwitchDisable = false;
     this.getAllControlHistory();
    },


  },
  computed: {
    ...mapState("scenicArea", { scenicAreaList: "allscenicArea" }),
    // ...mapGetters("iotEvent",{ iotEventList:"getIotEventData" }),
  },

  watch: {
    selectedScenicAreaId: {
      async handler(newVal) {
        await this.getAllControlHistory();
        this.checkSwitchsStatus();
 
      },
      immediate: true,
    },

    isSenicAreaControl: {
      async handler(newVal) {
        // this.getAllControlHistory();
      },
      immediate: true,
    },


  },

  async mounted() {
    my.info().then(a => {
      this.accountName = a.body.name;
    });

    this.dataInterval = setInterval(async () => {},
    CONST.REFRESH_DAT_TIMER_MIN);
  },

  destroyed() {
    if (this.dataInterval) clearInterval(this.dataInterval);
    this.dataInterval = null;
  },
};
</script>

<style lang="scss" scoped>


</style>

